<template>
  <b-modal
    :model-value="modelValue"
    @update:model-value="updateShowModal"
    id="login-modal"
    title="Пријава"
    dialog-class="pis-modal"
    hide-footer
  >
    <form
      ref="form"
      @keyup.enter="handleLogin"
      style="display: block !important"
    >
      <b-form-group>
        <label for="username-input">Корисничко име</label>
        <b-form-input
          placeholder="Корисничко име"
          id="username-input"
          v-model="username"
          required
        />
      </b-form-group>
      <b-form-group>
        <label for="password-input">Лозинка</label>
        <b-form-input
          placeholder="Лозинка"
          id="password-input"
          v-model="password"
          type="password"
          required
        />
      </b-form-group>
    </form>
    <div v-if="errorMessage" class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>
    <div class="modal-footer">
      <template class="d-block pis-modal">
        <div class="btn-group-2-1">
          <div class="div1">
            <b-button
              class="modal-btn cancel-btn btn-block"
              variant="pis"
              @click="cancel()"
            >
              Одустани
            </b-button>
          </div>
          <div class="div2">
            <b-button
              class="modal-btn ok-btn btn-block"
              variant="pis"
              @click="handleLogin()"
            >
              Пријава
            </b-button>
          </div>
          <div class="div3" v-if="promotion.length > 0">
            <router-link
              class="modal-btn-outline register-btn btn-block"
              @click.native="closeLogin"
              to="/promo"
              >Регистрација за ПРОМО период
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import * as userService from "../services/user-service";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import emitter from "@/eventBus";

export default {
  name: "LoginModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseApiUrl: window.env.VUE_APP_API_PENG_DEV,
      username: null,
      password: null,
      errorMessage: null,
      userType: null,
      promotion: [],
    };
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    cancel() {
      this.$emit("update:model-value", false);
      this.errorMessage = null;
    },
    handleLogin() {
      axios
        .post(this.baseApiUrl + "prins/login", {
          password: this.password,
          username: this.username,
        })
        .then((response) => {
          this.errorMessage = null;
          if (response.data.status === -2) {
            this.errorMessage =
              "Прекорачен је број максималних дозвољених сесија";
          } else if (response.data.status === -1) {
            this.errorMessage = "Унели сте погрешну лозинку или корисничко име";
          } else {
            this.setUserInfo(response.data);
             emitter.emit("userLoggedIn");
            this.$emit("update:modelValue", false); // Close modal on success

            axios
              .post(this.baseApiUrl + "prins/info")
              .then((response) => {
                if (response.status !== 204) {
                  let userData = response.data;
                  this.setUserInfo(userData);
                  userService.setUser(userData);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.status === -2) {
            this.errorMessage =
              "Прекорачен је број максималних дозвољених сесија";
          }
          if (error.response.data.status === -1) {
            this.errorMessage = "Унели сте погрешну лозинку или корисничко име";
          } else {
            this.errorMessage = "Дошло је до неочекиване грешке";
          }
        });
    },
    prevent(event) {
      if (this.userType === 1) {
        if (event.trigger === "backdrop") {
          event.preventDefault();
        } else if (event.trigger === "headerclose") {
          event.preventDefault();
        }
      }
    },
    closeLogin() {
      this.$emit("update:model-value", false);
    },
    updateShowModal(value) {
      this.$emit("update:model-value", value);
    },
  },
  computed: {
    ...mapState(["userInfoState"]),
  },
};
</script>

<style scoped>
.btn:first-child:active {
  color: #fff !important;
  background-color: #409edc !important;
  border-color: #409edc !important;
  box-shadow: 0 0 0 0.2rem rgba(31, 43, 56, 0.25);
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
